var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('MasterTemplate',{attrs:{"usePageHeader":true},scopedSlots:_vm._u([{key:"gnb",fn:function(){return [_c('GnbLeftView')]},proxy:true}])},[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }